import React, { Fragment } from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import { StixStars } from './'
import Modal from 'react-awesome-modal'

const SideBar = ({
  loadingPayment,
  disabledButton,
  partnerName = 'Stix',
  creditValue = 0,
  starValue = 0,
  pointsName,
  isModalConfirmationOpened,
  handlePaymentConfirmation,
  closeModal,
  formatTitle,
  isLoading,
  handlerFinalizePayment = () => {}
}) => {
  return (
    <Fragment>
      <div className='cart-side col-12 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'>
        <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
          <h3 className='color-title txt-font-body'>Resumo do resgate</h3>
        </div>
        <div className='cart-subtotal col-12 pb-3 mx-0'>
          <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
            <div className='col-9  txt-left  justify-content-center align-self-center'>
              <p className='txt-body-sm txt-font-body color-ui-2'>
                Transferência: <strong>{partnerName || 'Stix'}</strong>
              </p>
              <p className='txt-body-sm  txt-font-body color-ui-2'>
                Valor em pontos:{' '}
                <strong className='txt-lowercase'> {creditValue === '' ? 0 : creditValue} {pointsName} </strong>
              </p>
              <p className='txt-body-sm txt-font-body color-ui-2'>
                Valor em pontos stix:{' '}
                <strong> <StixStars totalStars={starValue} /> </strong>
              </p>
            </div>
          </div>
          <div className='row product-brand pt-3  px-2'>
            <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
              <p className='txt-subtitle txt-font-body color-ui-2' data-partnername={partnerName}>
                Ao clicar em finalizar transferência, seus pontos serão transferidos para a Stix.
              </p>
            </div>
          </div>
          <div className='cart-done row  px-2 pt-2 '>
            <div className='col-12 justify-content-center align-self-center'>
              <Button
                loading={isLoading}
                className='btn-featured btn-icon'
                disabled={disabledButton()}
                text='transferir pontos'
                iconName='icon_gift icon-sm'
                onClick={handlePaymentConfirmation}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        width='580'
        height='0'
        effect='fadeInUp'
        visible={isModalConfirmationOpened}
      >
        <div
          className='col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto pos-absolute'
          style={{
            top: '-243px'
          }}
        >
          <div className='row px-3 border-color-ui-3 border-bottom pb-2 mb-2'>
            <div className='col'>
              <h3 className='txt-font-title'>Confirmação de transferência</h3>
            </div>
          </div>
          <div className='row px-3'>
            <div className='col'>
              <p className='txt-body-sm txt-font-body color-ui-2'>
                Você está transferindo {creditValue === '' ? 0 : creditValue} <span className='txt-lowercase'>{pointsName}</span> {formatTitle(process.env.REACT_APP_TITLE)} para a Stix.
                <br />
                Deseja confirmar a transferência?
              </p>
            </div>
          </div>
          <div className='col-12 pt-3'>
            <div className='row px-2'>
              <div className='modal-back col-6 txt-right'>
                <Button
                  className='btn btn-sm mx-0'
                  text='Cancelar'
                  onClick={closeModal}
                />
              </div>
              <div className='modal-back col-6 txt-right'>
                {loadingPayment ? (
                  <button
                    className='btn-featured btn-icon'
                    aria-label='Carregando...'
                    disabled={disabledButton}
                  >
                    <div className='btn-loading mr-auto ml-auto'>
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </button>
                ) : (
                  <Button
                    className='btn btn-sm btn-featured mx-0'
                    text='Confirmar transferência'
                    onClick={handlerFinalizePayment}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

SideBar.propTypes = {
  loadingPayment: PropTypes.bool,
  disabledButton: PropTypes.func,
  partnerName: PropTypes.string,
  creditValue: PropTypes.number,
  starValue: PropTypes.number,
  handlerFinalizePayment: PropTypes.func,
  pointsName: PropTypes.string,
  isModalConfirmationOpened: PropTypes.bool,
  handlePaymentConfirmation: PropTypes.func,
  closeModal: PropTypes.func,
  formatTitle: PropTypes.func,
  isLoading: PropTypes.bool
}
export default SideBar



// WEBPACK FOOTER //
// ./src/features/Stix/SideBar.js